import type { ComponentType } from 'react';

import { Blocks } from '@/core/types';

import { View500, View403, NotFoundView } from '@/containers/sections/error';

import FAQ from './faq';
import Text from './text';
import Html from './html';
import Contact from './contact';
import BannerV1 from './banner-v1';
import BannerV2 from './banner-v2';
import BannerV3 from './banner-v3';
import Breadcrumb from './breadcrumb';
import Newsletter from './newsletter';
import ComingSoon from './coming-soon';
import ImageTextV1 from './image-text-v1';
import ImageTextV2 from './image-text-v2';
import ReviewSlider from './review-slider';
import BigImageText from './big-image-text';
import TrialOfferV1 from './trial-offer-v1';
import FeatureTabsV1 from './feature-tabs-v1';
import ImageTextGrid from './image-text-grid';
import FeatureStepsV1 from './feature-steps-v1';
import SmallImageText from './small-image-text';
import TextAndService from './text-and-service';
import UnitPackPricing from './unit-pack-pricing';
import SuggestedFeatures from './suggested-features';
import FeatureCategoriesV1 from './features-categories';
import FeatureServicesTabs from './feature-services-tabs';
import PackagePricingPlans from './package-pricing-plans';
import BannerWithWhiteText from './banner-with-white-text';

export type SectionGenerators = {
  [key: string]: ComponentType<any>;
};

const sectionGenerators: SectionGenerators = {
  [Blocks.TechnicalName.BANNER]: BannerV1,
  [Blocks.TechnicalName.BANNER_V2]: BannerV2,
  [Blocks.TechnicalName.BANNER_V3]: BannerV3,
  [Blocks.TechnicalName.BANNER_WITH_WHITE_TEXT]: BannerWithWhiteText,
  [Blocks.TechnicalName.FEATURE_STEPS_V1]: FeatureStepsV1,
  [Blocks.TechnicalName.FEATURE_TABS_V1]: FeatureTabsV1,
  [Blocks.TechnicalName.FEATURES_CATEGORIES]: FeatureCategoriesV1,
  [Blocks.TechnicalName.IMAGE_TEXT_GRID]: ImageTextGrid,
  [Blocks.TechnicalName.IMAGE_TEXT_V1]: ImageTextV1,
  [Blocks.TechnicalName.IMAGE_TEXT_V2]: ImageTextV2,
  [Blocks.TechnicalName.BIG_IMAGE_TEXT]: BigImageText,
  [Blocks.TechnicalName.SMALL_IMAGE_TEXT]: SmallImageText,
  [Blocks.TechnicalName.NEWSLETTER]: Newsletter,
  [Blocks.TechnicalName.PACKAGE_PRICING_PLANS]: PackagePricingPlans,
  [Blocks.TechnicalName.REVIEW_SLIDER]: ReviewSlider,
  [Blocks.TechnicalName.SUGGESTED_FEATURES]: SuggestedFeatures,
  [Blocks.TechnicalName.TRIAL_OFFER_V1]: TrialOfferV1,
  [Blocks.TechnicalName.UNIT_PACK_PRICING]: UnitPackPricing,
  [Blocks.TechnicalName.FEATURE_SERVICES_TABS]: FeatureServicesTabs,
  [Blocks.TechnicalName.BREADCRUMB]: Breadcrumb,
  [Blocks.TechnicalName.FAQ]: FAQ,
  [Blocks.TechnicalName.TEXT]: Text,
  [Blocks.TechnicalName.TEXT_AND_SERVICE]: TextAndService,
  [Blocks.TechnicalName.COMING_SOON]: ComingSoon,
  [Blocks.TechnicalName.ERROR_500]: View500,
  [Blocks.TechnicalName.ERROR_404]: NotFoundView,
  [Blocks.TechnicalName.ERROR_403]: View403,
  [Blocks.TechnicalName.CONTACT]: Contact,
  [Blocks.TechnicalName.HTML]: Html,
};

export default sectionGenerators;
